<template>
  <div>
    <p class="mb-0" v-if="isP">
      <template v-if="strongP"
        ><strong>${{ formatValue }}</strong></template
      >
      <template v-else>${{ formatValue }}</template>
    </p>
    <div v-else :class="listClass">
      <template v-if="messageLabel">
        <template v-if="strongMessageLabel">
          <strong>{{ translateMessageLabel }}</strong>
        </template>
        <template v-else>
          {{ translateMessageLabel }}
        </template>
        ${{ formatValue }}
      </template>
      <template v-else> ${{ formatValue }} </template>
      <template v-if="messageTooltip && messageTooltip !== ''">
        <el-tooltip class="item" effect="dark" placement="bottom">
          <div slot="content">
            <span v-html="translateTooltip"></span>
          </div>
          <em class="fa fa-info-circle" aria-hidden="true"></em>
        </el-tooltip>
      </template>
    </div>
  </div>
</template>
<script>
import Formatter from 'src/class/Formatter';

export default {
  name: 'formatmoney',
  props: {
    value: String | Number,
    strongMessageLabel: {
      type: Boolean,
      default: false,
    },
    messageLabel: {
      type: String | Array,
      default: null,
    },
    messageTooltip: {
      type: String | Array,
      default: '',
    },
    listClass: {
      type: String,
      default: 'align-info',
    },
    isP: {
      type: Boolean,
      default: false,
    },
    strongP: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    formatValue() {
      return Formatter.formatMoney(Number(this.value));
    },
    translateTooltip() {
      if (Array.isArray(this.messageTooltip)) {
        return this.messageTooltip
          .map((item) => {
            return this.$i18n.t(item);
          })
          .join('');
      } else return this.messageTooltip;
    },
    translateMessageLabel() {
      if (Array.isArray(this.messageLabel)) {
        return this.messageLabel
          .map((item) => {
            return this.$i18n.t(item);
          })
          .join('');
      } else return this.messageLabel;
    },
  },
};
</script>
<style>
.align-info {
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
.align-info em {
  color: cadetblue;
  font-size: 20px;
}
</style>
